import { render, staticRenderFns } from "./SidebarAction.vue?vue&type=template&id=34010e44"
import script from "./SidebarAction.vue?vue&type=script&lang=js"
export * from "./SidebarAction.vue?vue&type=script&lang=js"
import style0 from "./SidebarAction.vue?vue&type=style&index=0&id=34010e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports